/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pxk_Already_Received_NoteInputs */

const vi_pxk_already_received_note = /** @type {(inputs: Pxk_Already_Received_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu xuất này đã có phiếu nhập kho tiếp nhận`)
};

/**

* @param {Pxk_Already_Received_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pxk_already_received_note = /** @type {((inputs?: Pxk_Already_Received_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pxk_Already_Received_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pxk_already_received_note(inputs)
});